<span #mathField role="img" [attr.aria-label]="getAccessibleText()"></span>
